import React from 'react';
import tw, { styled } from 'twin.macro';

import { useTheme } from '../../../hooks/index';

const StyledWindow = styled.div`
  ${tw`w-full h-full flex flex-col absolute top-0`}
  box-sizing: border-box;

  *:not(h1) {
    ${props => `font-family: '${props.theme.bodyFont}', sans-serif;`}
  }
`;

const Window = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <StyledWindow data-testid="embed-window" theme={theme} {...props}>
      {children}
    </StyledWindow>
  );
};

export default Window;
